import { FiscalPrintEnableCommand, FiscalPrintEnabledQuery } from '@dreryk/egabinet-invoice-frontend-api';

import { refetchCqrsQuery, useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { invoicePanelTranslationKeys } from '../translations';

import { InvoiceFiscalPrintIntegrationToggleFormBean } from './InvoiceFiscalPrintIntegrationToggle.types';

export const useInvoiceFiscalPrintEnableCommand = (): UseCqrsCommandResult<
   void,
   InvoiceFiscalPrintIntegrationToggleFormBean
> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new FiscalPrintEnableCommand();
         command.enabled = parameters.fiscalPrintIntegrationEnabled;
         return command;
      },
      {
         onSuccess: (_, parameters) => {
            refetchCqrsQuery(FiscalPrintEnabledQuery);
            dispatchSnackbarPositiveEvent(
               parameters.fiscalPrintIntegrationEnabled
                  ? invoicePanelTranslationKeys.fiscalPrintIntegration.saveSuccessEnabled
                  : invoicePanelTranslationKeys.fiscalPrintIntegration.saveSuccessDisabled
            );
         },
         onUnexpectedError: () => {
            dispatchSnackbarNegativeEvent(invoicePanelTranslationKeys.fiscalPrintIntegration.saveError);
         },
      }
   );
};
